import styled, { createGlobalStyle } from 'styled-components';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledTranslationMenu = styled('div')`
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px ${COLOR.boxShadow};
  padding: 8px;
  box-sizing: border-box;
  width: 224px;

  .item {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    height: 40px;
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    width: 100%;
    gap: 10px;

    &:hover {
      color: ${COLOR.text};
      background-color: ${TRANSPARENT_COLOR.dark};
    }
  }
`;

export const StyledTranslationDropdown = styled('div')``;

export const GlobalTooltipStyle = createGlobalStyle`
  .rc-tooltip-placement-bottom,
  .rc-tooltip-placement-bottomLeft,
  .rc-tooltip-placement-bottomRight {
    padding: 0 !important;
  }
`;
